import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-outfit font-800 text-white mb-4">
              AI <span className="text-crimson">Day</span>
            </h3>
            <p className="text-gray-300 font-outfit font-600 mb-4">
              An <a href="https://aianytime.net/" target="_blank" rel="noopener noreferrer" className="hover:text-crimson transition-colors">AI Anytime</a> Initiative
            </p>
            <p className="text-gray-300 font-outfit font-600 mb-6">
              Sankhyantra Foundation
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.youtube.com/@AIAnytime" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-crimson transition-colors"
                aria-label="YouTube"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
              <a 
                href="https://www.linkedin.com/company/ai-anytime/?viewAsMember=true" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-crimson transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a 
                href="https://aianytime.net/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-crimson transition-colors"
                aria-label="Website"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"/>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-outfit font-800 text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-400 hover:text-crimson transition-colors font-outfit font-600">
                  About AI Day
                </a>
              </li>
              <li>
                <a href="#events" className="text-gray-400 hover:text-crimson transition-colors font-outfit font-600">
                  Events
                </a>
              </li>
              <li>
                <a href="#host" className="text-gray-400 hover:text-crimson transition-colors font-outfit font-600">
                  Partner With Us
                </a>
              </li>
              <li>
                <a 
                  href="https://aianytime.net/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-crimson transition-colors font-outfit font-600"
                >
                  AI Anytime
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-outfit font-800 text-lg mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-crimson transition-colors font-outfit font-600">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/code-of-conduct" className="text-gray-400 hover:text-crimson transition-colors font-outfit font-600">
                  Code of Conduct
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-crimson transition-colors font-outfit font-600">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-crimson pt-8">
          <p className="text-center text-gray-300 font-outfit font-600">
            &copy; {new Date().getFullYear()} AI Day. All rights reserved. An initiative by Sankhyantra Foundation.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
